import { TransformationProtocolDTO } from "../DTO/transformationProtocolDTO";
import { TransformationProtocolAI } from "../responses/generateTransformationResponse";
import { FieldDefinition } from "./fieldDefinition";
import { InputFieldReference } from "./inputFieldReference";
import { OutputFieldReference } from "./outputFieldReference";
import { TransformationNode } from "./transformationNode";
import { TransformationRule } from "./transformationRule";

export class TransformationProtocol{

    public id!: number;
    public inputFieldDefinitions!: FieldDefinition[];
    public inputFieldReferences!: InputFieldReference[];
    public outputFieldIndex!: number;
    public outputFieldName!: string;
    public outputFieldLength!: number; //for fl
    public transformationRules!: TransformationRule[]; //list of rules to be executed. Input is either file input or output of previous rule. Sequence determined by rules SequenceNo attribute.
    public isOutputParameter!: boolean;
    public startNewRecord!: boolean; //for mrt (multi record type)
    public groupingLevel!: number; //for grt (grouped record type) and mrt (multi record types). Starts with 1. 0 means no grouping (default)
    public outputFieldReference!: OutputFieldReference;
    
    public transformationNode!: TransformationNode;
    public copyFieldsFromPreviousRecord:boolean=false; //helper field to make new MRT block the same as previous MRT block

    constructor(){
        this.transformationRules = new Array();
        this.inputFieldDefinitions = new Array();
        this.isOutputParameter = true; //for now we decided to mark all protocols as output parameters. No UI support needed as of now.
        this.startNewRecord = false;
    }

    public relateInputFieldDefinitions(fieldDefinitions:FieldDefinition[]){
        this.inputFieldDefinitions = new Array();
        if(this.inputFieldReferences) this.inputFieldReferences.forEach(ref=>{
            let fd = fieldDefinitions.find(f=>f.index==ref.index);
            if(fd) this.inputFieldDefinitions.push(fd);
        })
    }

    get clone(){
        let cloneProtocol =  new TransformationProtocol();
        Object.assign(cloneProtocol, this);
        return cloneProtocol;
    }

    public static mapFromDTO(param:TransformationProtocolDTO):TransformationProtocol{ 
        if (!param) throw new Error("parameter is null")
        let obj = new TransformationProtocol();
        try
        {
            obj.id = param.id;
            if(param.inputFieldReferences){
                obj.inputFieldReferences = JSON.parse(param.inputFieldReferences);
            } 
            obj.outputFieldIndex = param.outputFieldIndex;
            obj.outputFieldName = param.outputFieldName;
            obj.outputFieldLength = param.outputFieldLength;
            obj.transformationRules = param.transformationRules.map(tr=>TransformationRule.mapFromDTO(tr));
            obj.isOutputParameter = param.isOutputParameter;
            obj.startNewRecord = param.startNewRecord;
            obj.groupingLevel = param.groupingLevel;
            obj.outputFieldReference = new OutputFieldReference(obj.outputFieldIndex, obj.outputFieldName);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:TransformationProtocol):TransformationProtocolDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new TransformationProtocolDTO();
        try
        {
            dto.id = param.id;
            if(param.inputFieldDefinitions && param.inputFieldDefinitions.length>0) dto.inputFieldReferences = JSON.stringify(param.inputFieldDefinitions.map(r=>r.inputFieldReference));
            dto.outputFieldIndex = param.outputFieldIndex;
            dto.outputFieldName = param.outputFieldName;
            dto.outputFieldLength = param.outputFieldLength;
            dto.transformationRules = param.transformationRules.map(tr=>TransformationRule.mapToDTO(tr));
            dto.isOutputParameter = param.isOutputParameter;
            dto.startNewRecord = param.startNewRecord;
            dto.groupingLevel = param.groupingLevel;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public static mapFromAI(param:TransformationProtocolAI):TransformationProtocol{ 
        if (!param) throw new Error("parameter is null")
        let obj = new TransformationProtocol();
        try
        {
            obj.id = param.id;
            obj.inputFieldReferences = param.inputFieldReferences;
            obj.outputFieldIndex = param.outputFieldIndex;
            obj.outputFieldName = param.outputFieldName;
            obj.outputFieldLength = param.outputFieldLength? param.outputFieldLength:0;
            obj.transformationRules = param.transformationRules.map(tr=>TransformationRule.mapFromAI(tr));
            obj.isOutputParameter = param.isOutputParameter;
            obj.startNewRecord = param.startNewRecord;
            obj.groupingLevel = param.groupingLevel;
            obj.outputFieldReference = new OutputFieldReference(obj.outputFieldIndex, obj.outputFieldName);
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public descriptiveTransformationParameter(transformationRuleIndex:number, transformationParameterIndex:number){
        var parameter = this.transformationRules[transformationRuleIndex]?.transformationParameter(transformationParameterIndex);
        if(this.transformationRules[transformationRuleIndex]?.transformationRuleDefinition.getParameterLabel(transformationParameterIndex)?.type=="opt-inputfields"){
            if(!isNaN(Number(parameter))) return this.inputFieldDefinitions[Number(parameter)]?.name;
            else return parameter;
        }
        else return parameter;
    }
}